export default __webpack_public_path__ + "static/media/email-read.8efa509f.svg";